import { AlertTriangle, CheckCircle2, XCircle } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { mandateService } from "@/services/apiServices";

type Outcome = "success" | "declined" | "failed";

const OPTIONS: {
  outcome: Outcome;
  title: string;
  sub: string;
  icon: typeof CheckCircle2;
  row: string;
  iconCls: string;
}[] = [
  {
    outcome: "success",
    title: "Approve mandate",
    sub: "Mandate becomes ACTIVE with a UMRN",
    icon: CheckCircle2,
    row: "border-emerald-600 text-emerald-700 hover:bg-emerald-50",
    iconCls: "text-emerald-600",
  },
  {
    outcome: "declined",
    title: "Decline mandate",
    sub: "Customer rejected the request",
    icon: XCircle,
    row: "border-danger text-danger hover:bg-danger-bg",
    iconCls: "text-danger",
  },
  {
    outcome: "failed",
    title: "Simulate failure",
    sub: "Bank timeout or technical error",
    icon: AlertTriangle,
    row: "border-warning text-warning hover:bg-warning-bg",
    iconCls: "text-warning",
  },
];

export default function SimulationStep() {
  const { refNo = "" } = useParams();
  const navigate = useNavigate();

  function choose(outcome: Outcome) {
    const outcomeUpper = outcome === "success" ? "SUCCESS" : outcome === "declined" ? "DECLINED" : "FAILED";
    mandateService
      .simulateAuth(refNo, outcomeUpper)
      .finally(() => {
        navigate(`/auth/${refNo}/status?outcome=${outcome}`);
      });
  }

  return (
    <div className="flex flex-col items-center text-center">
      <h2 className="mt-1 text-lg font-semibold text-ink">Simulate bank response</h2>
      <p className="mt-1 text-[13px] text-ink-secondary">
        Choose an outcome to test how the system behaves.
      </p>
      <div className="mt-5 flex w-full flex-col gap-3">
        {OPTIONS.map((o) => (
          <button
            key={o.outcome}
            type="button"
            onClick={() => choose(o.outcome)}
            className={`flex h-14 w-full items-center gap-3 rounded-[10px] border bg-white px-4 transition-colors cursor-pointer ${o.row}`}
          >
            <o.icon className={`h-5 w-5 shrink-0 ${o.iconCls}`} />
            <span className="flex-1 text-left">
              <span className="block text-sm font-medium text-ink">{o.title}</span>
              <span className="block text-xs text-ink-secondary">{o.sub}</span>
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}